import SavedPaymentMethods from 'components/SavedPaymentMethods';
import React, { useState } from 'react';
import styles from './index.module.scss';

const ChangePaymentMethodModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<Record<string, any>>({});
  const {
    userId,
    toggleModal,
    title,
    onPaymentMethodChange,
  } = props;

  const onSubmit = async () => {
    setLoading(true);
    await onPaymentMethodChange(selectedPaymentMethod);
    setLoading(false);
  };
  
  const getSavedPaymentMethods = () => {
    return <SavedPaymentMethods
      user={{ objectId: userId }}
      disabled={false}
      selectedPaymentId={selectedPaymentMethod}
      setPaymentId={val => setSelectedPaymentMethod(val)}
    />;
  };
  
  return (
    <form onSubmit={e => e.preventDefault()} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>PaymentMethod</div>
            <div className={styles['modal-title']}>{title}</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {getSavedPaymentMethods()}
        </div>
        <div className={styles['modal-footer']}>
          <button
            type={'button'}
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'button'}
            className={styles['submit-button']}
            disabled={loading || !Object.keys(selectedPaymentMethod).length}
            onClick={onSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default ChangePaymentMethodModal;